export enum ProductActions {
  AMOUNT = 'action_amount',
  CANCEL = 'action_cancel'
}

